import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IPromise, IWindowService} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {MeldingTilBruker} from "../../../../../felles/tjenester/MeldingTilBruker";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {erLikIgnorerRekkefølge} from "../../../../../felles/stoettefunk/lister";
import {MøteRessurs} from "../../../../../felles/tjenester/ressurser/MøteRessurs";
import {uriEnkodet} from "../../../../../felles/stoettefunk/uri";
import {SaksdokumentDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";
import {firstValueFrom} from "rxjs";
import {kopierFraNg2TilAjs} from "felles-ng2/modell/ajsNg2ModellBroer";

const debug: Debugger = require('debug')('RegistrerEksterntSignertProtokollDialog');
require('./møtedokumentValgDialog.scss');


export class MøtedokumentValgDialog implements MdDialogController {

    static visMøtedokumentValgDialog($mdDialog: angular.material.IDialogService, møte: l.MøteModell): IPromise<void> {
        debug('visMøtedokumentValgDialog', møte)
        return $mdDialog.show(this.dialogKonfigurasjon({moete: møte}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./møtedokumentValgDialog.html'),
            controller: MøtedokumentValgDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            regNavn.ng.$window,
            regNavn.md.$mdDialog,
            MøteRessurs.regNavn,
            ng2RegNavn.SaksdokumentDatatjenesteForAjs,
            MeldingTilBruker.regNavn,
            regNavn.gettext.gettextCatalog,
            MøtedokumentValgDialog
        ]
    }

    constructor(private $window: IWindowService,
                private $mdDialog: angular.material.IDialogService,
                private møteRessurs: MøteRessurs,
                private saksdokumentDatatjenesteForAjs: SaksdokumentDatatjenesteForAjs,
                private meldingTilBruker: MeldingTilBruker,
                private gettextCatalog: gettextCatalog) {
    }

    moete: l.MøteModell; //settes via locals

    tilgjengeligeDokumentdeler: Dokumentdel[] = [];
    tilgjengeligeSakerOgSaksdokumenter: Dokumentdel[] = [];
    inkluderteDeler: Dokumentdel[] = [];
    genererTosidig = false;
    huskValg = false;

    lagrer = false;
    initialisert = false;

    private møtedokumentvalg: l.MøtedokumentvalgModell;

    inkluderteDelerEndret() {
        this.tilgjengeligeDokumentdeler.forEach(element => element.valgt = false);
        this.tilgjengeligeSakerOgSaksdokumenter.forEach(element => element.valgt = false);
        this.inkluderteDeler.forEach(element => element.valgt = true)
    }

    utelatteDelerSomHtml() {
        let utelatteDeler = this.tilgjengeligeDokumentdeler
            .filter(del => !del.valgt)
            .map(del => `<div>${del.navnHtml(this.gettextCatalog)}</div>`).join('\n')
          + this.tilgjengeligeSakerOgSaksdokumenter
            .filter(del => !del.valgt)
            .map(del => `<div>${del.navnHtml(this.gettextCatalog)}</div>`).join('\n');
        if (_.isEmpty(utelatteDeler)) return this.gettextCatalog.getString('Velg hva som skal være med i møtedokumentet');
        return utelatteDeler;
    }

    erMoetedokumentvalgEndret() {
        if (this.møtedokumentvalg == null) return false;
        const spesifikasjon = this.somOppdaterMøtedokumentvalgSpesifikasjon();
        if (this.møtedokumentvalg.genereMoetedokumentTosidig != this.genererTosidig) return true;
        if (!erLikIgnorerRekkefølge(this.møtedokumentvalg.utelatteMoetedokumentdeler, spesifikasjon.utelatteMoetedokumentdeler)) return true;
        if (!erLikIgnorerRekkefølge(this.møtedokumentvalg.utelatteSaker, spesifikasjon.utelatteSaker)) return true;
        if (!erLikIgnorerRekkefølge(this.møtedokumentvalg.utelatteSaksdokumenter, spesifikasjon.utelatteSaksdokumenter)) return true;
        return false;
    }

    erInkluderteDokumentdelerEndret() {
        if (this.møtedokumentvalg == null) return false;
        if (this.møtedokumentvalg.genereMoetedokumentTosidig != this.genererTosidig) return true;
        if (!erLikIgnorerRekkefølge(this.møtedokumentvalg.utelatteMoetedokumentdeler, this.utelatteDokumentdelerSomMøtedokumentdelListe())) return true;
        return false;
    }

    lagreValg() {
        this.lagrer = true;
        this.møteRessurs.oppdaterMøtedokumentvalg(this.moete.id, this.somOppdaterMøtedokumentvalgSpesifikasjon()).$promise
          .then(oppdaterteValg => {
              this.møtedokumentvalg = oppdaterteValg;
              this.meldingTilBruker.infomelding(this.gettextCatalog.getString('Møtedokumentvalg lagret'));
          })
          .finally(() => {
              this.lagrer = false;
          });
    }

    genererPdf() {
        this.$mdDialog.hide();
        let url = this.møteRessurs.møtedokumentUrl(this.moete);
        if (this.erMoetedokumentvalgEndret())
            url = url + '?' + this.somQueryparameter();
        this.$window.open(url, "_blank");
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit() {
        this.møteRessurs.hentMøtedokumentvalg(this.moete.id).$promise.then(valg => this.møtedokumentvalgLastet(valg));
        this.tilgjengeligeDokumentdeler.push(Dokumentdel.fraDokumentdel(l.Møtedokumentdel.innholdsfortegnelse, this.gettextCatalog.getString('Innholdsfortegnelse')))
        this.tilgjengeligeDokumentdeler.push(Dokumentdel.fraDokumentdel(l.Møtedokumentdel.saksforside, this.gettextCatalog.getString('Saksforside')))
        //ikke nødv å kalle tjenestekallOmsluttetIAjsApplyAsync() da det digest garantert blir kalt på et senere tidspunkt
        this.saksdokumentDatatjenesteForAjs.tjeneste().then(saksdokumentDatatjeneste => {
            this.moete.saker
              .filter(sak => !sak.erPause)
              .forEach(sak => {
                  firstValueFrom(saksdokumentDatatjeneste.finnTilknyttetSakFraLokallager(sak.id))
                    .then(dokumenter => kopierFraNg2TilAjs<l.SaksdokumentModell[]>(dokumenter))
                    .then(dokumenter => {
                        let dokumentdelSak = Dokumentdel.fraSak(sak);
                        this.tilgjengeligeSakerOgSaksdokumenter.push(dokumentdelSak);
                        dokumenter.forEach(dokument =>
                          this.tilgjengeligeSakerOgSaksdokumenter.push(Dokumentdel.fraSaksdokument(dokument, dokumentdelSak, this.gettextCatalog)));
                    });
              });
        });
    }

    //private

    private møtedokumentvalgLastet(valg: l.MøtedokumentvalgModell) {
        this.møtedokumentvalg = valg;
        this.genererTosidig = valg.genereMoetedokumentTosidig;
        this.tilgjengeligeDokumentdeler
          .forEach(kandidat => {
              kandidat.valgt = !_.includes(valg.utelatteMoetedokumentdeler, kandidat.id)
              if (kandidat.valgt) this.inkluderteDeler.push(kandidat)
          });
        this.tilgjengeligeSakerOgSaksdokumenter
          .filter(kandidat => kandidat.type == 'sak')
          .forEach(kandidat => {
              kandidat.valgt = !_.includes(valg.utelatteSaker, kandidat.id)
              if (kandidat.valgt) this.inkluderteDeler.push(kandidat)
          });
        this.tilgjengeligeSakerOgSaksdokumenter
          .filter(kandidat => kandidat.type == 'saksdokument')
          .forEach(kandidat => {
              kandidat.valgt = !_.includes(valg.utelatteSaksdokumenter, kandidat.id)
              if (kandidat.valgt) this.inkluderteDeler.push(kandidat)
          });
        this.initialisert = true;
    }

    private somOppdaterMøtedokumentvalgSpesifikasjon(): l.OppdaterMøtedokumentvalgSpesifikasjon {
        return {
            utelatteSaker: this.utelatteDokumentdelerSomSaksidListe(),
            utelatteSaksdokumenter: this.utelatteDokumentdelerSomDokumentidListe(),

            settSomStandardForGruppe: this.huskValg,
            genereMoetedokumentTosidig: this.genererTosidig,
            utelatteMoetedokumentdeler: this.utelatteDokumentdelerSomMøtedokumentdelListe()
        }
    }

    private somQueryparameter(): string {
        return 'utelatteSaker=' + this.somUriEnkodetKommasepparert(this.utelatteDokumentdelerSomSaksidListe()) + '&' +
          'utelatteSaksdokumenter=' + this.somUriEnkodetKommasepparert(this.utelatteDokumentdelerSomDokumentidListe()) + '&' +
          'genereMoetedokumentTosidig=' + this.genererTosidig + '&' +
          'utelatteMoetedokumentdeler=' + this.somUriEnkodetKommasepparert(this.utelatteDokumentdelerSomMøtedokumentdelListe());
    }

    private utelatteDokumentdelerSomSaksidListe(): string[] {
        return this.tilgjengeligeSakerOgSaksdokumenter.filter(utelatt => utelatt.type == 'sak' && !utelatt.valgt).map(utelatt => <string>utelatt.id);
    }

    private utelatteDokumentdelerSomDokumentidListe(): string[] {
        return this.tilgjengeligeSakerOgSaksdokumenter.filter(utelatt => utelatt.type == 'saksdokument' && !utelatt.valgt).map(utelatt => <string>utelatt.id);
    }

    private utelatteDokumentdelerSomMøtedokumentdelListe(): l.Møtedokumentdel[] {
        return this.tilgjengeligeDokumentdeler.filter(utelatt => !utelatt.valgt).map(utelatt => <l.Møtedokumentdel>utelatt.id);
    }

    private somUriEnkodetKommasepparert(liste: string[] | l.Møtedokumentdel[]) {
        if (_.isNil(liste)) return '';
        return uriEnkodet(liste.join(','));
    }

}

class Dokumentdel {
    navn: string;
    klasser: { [klassenavn: string]: boolean };
    id: string | l.Møtedokumentdel;
    type: 'dokumentdel' | 'sak' | 'saksdokument';
    forelder?: Dokumentdel;
    barn: Dokumentdel[] = [];
    valgt = false;

    static fraSak(sak: l.AgendaelementModell): Dokumentdel {
        const instans = new Dokumentdel();
        instans.navn = `${sak.nummer} ${sak.tittel}`;
        instans.klasser = {'vm-mvd-del vm-mvd-del-sak': true};
        instans.id = sak.id;
        instans.type = 'sak';
        return instans;
    }

    static fraSaksdokument(dokument: l.SaksdokumentModell, forelder: Dokumentdel, gettextCatalog: gettextCatalog): Dokumentdel {
        const instans = new Dokumentdel();
        instans.navn = _.isNil(dokument.antallSider) ? dokument.filnavn : gettextCatalog.getPlural(dokument.antallSider, '{{filnavn}} ({{antallsider}} side)', '{{filnavn}} ({{antallsider}} sider)', {'filnavn': dokument.filnavn, 'antallsider': dokument.antallSider});
        instans.klasser = {'vm-mvd-del vm-mvd-del-saksdokument': true};
        instans.id = dokument.dokumentId;
        instans.type = 'saksdokument';
        instans.forelder = forelder;
        forelder.barn.push(instans);
        return instans;
    }

    static fraDokumentdel(del: l.Møtedokumentdel, navn: string): Dokumentdel {
        const instans = new Dokumentdel();
        instans.navn = navn;
        instans.klasser = {'vm-mvd-del vm-mvd-del-dokumentdel': true};
        instans.id = del;
        instans.type = 'dokumentdel';
        return instans;
    }

    navnHtml(gettextCatalog: gettextCatalog) {
        let html = this.navn;
        if (this.type == "sak")
            html = gettextCatalog.getString('Sak {{navn}} (hele saken utelatt)', {'navn': this.navn});
        if (this.type == "saksdokument")
            html = gettextCatalog.getString('{{navn}} (under sak {{foreldernavn}})', {'navn': this.navn, 'foreldernavn': this.forelder.navn});
        return html;
    }

    erTilgjengeligForValg() {
        return this.forelder?.valgt !== false;
    }
}
